import { createStore, combineReducers } from 'redux';
import { basename } from 'path';

const reducers = {};

function importAll(r) {
  r.keys().forEach((key) => {
    const module = r(key).default;
    const name = basename(key, '.js');
    reducers[name] = module;
  });
}

importAll(require.context('./reducers/', false, /\.js$/));
const combinedReducers = combineReducers(reducers);

const store = createStore(
  combinedReducers,
  /* eslint-disable no-underscore-dangle */
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  /* eslint-enable */
);

export default store;
